// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-2 {
    padding-left: 150px;
    padding-right: 150px;
}

.container-2 {
    width: 100%;
    display: flex;
    height: max-content;
    /* background-color: lightgray; */
}

.left-2 {
    width: 50%;
    display: flex;
    height: max-content;
    justify-content: center;
    align-items: center;
}

.right-2 {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.main-2 {
    font-size: 2.5rem;
    line-height: 46px;
    letter-spacing: 0;
    font-weight: 700;
    width: 80%;
    text-align: start;
}
.image-con{
    position: relative;
    width: 700px;
    height: 500px;
    transform-style: preserve-3d;
    perspective: 1000px;
}
.image-con img{
    position: absolute;
    backface-visibility: hidden;
    transition: 1s;
}
.image-con img:nth-child(2){
    transform: rotateY(180deg);
}
.image-con:hover img:nth-child(2) {
    transform: rotateY(0deg);
}
.image-con:hover img:nth-child(1) {
    transform: rotateY(-180deg);
}

.imgflipw{
    width:80%
}

@media(max-width:1000px){
    .imgflipw{
        width:100%;
        display: flex;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }
}

@media (max-width: 800px) {
    .imgflipw{
        width:80%
    }
    .main-container-2 {
        padding-left: 10px;
        padding-right: 10px;
    }

    .container-2 {
        flex-direction: column;
    }

    .left-2 {
        width: 100%;
        margin-top: 30px;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .right-2 {
        width: 100%;
        align-items: center;
        justify-content: center;
    }

    .main-2 {
        padding: 0 20px;
        text-align: start;
        width: 100%;
        font-size: 1rem;
        line-height: 26px;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
    }
        .image-con {
            position: relative;
            width: 700px;
            height: 500px;
            transform-style: preserve-3d;
            perspective: 1000px;
            display: flex;
            justify-content: center;
        }
    
        .image-con img {
            position: absolute;
            backface-visibility: hidden;
            transition: 1s;
        }
    
        .image-con img:nth-child(2) {
            transform: rotateY(180deg);
        }
    
        .image-con:hover img:nth-child(2) {
            transform: rotateY(0deg);
        }
    
        .image-con:hover img:nth-child(1) {
            transform: rotateY(-180deg);
        }
  
}`, "",{"version":3,"sources":["webpack://./src/Home/Second.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,2BAA2B;QAC3B,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;IACpB;QACI;YACI,kBAAkB;YAClB,YAAY;YACZ,aAAa;YACb,4BAA4B;YAC5B,mBAAmB;YACnB,aAAa;YACb,uBAAuB;QAC3B;;QAEA;YACI,kBAAkB;YAClB,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,0BAA0B;QAC9B;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;YACI,2BAA2B;QAC/B;;AAER","sourcesContent":[".main-container-2 {\n    padding-left: 150px;\n    padding-right: 150px;\n}\n\n.container-2 {\n    width: 100%;\n    display: flex;\n    height: max-content;\n    /* background-color: lightgray; */\n}\n\n.left-2 {\n    width: 50%;\n    display: flex;\n    height: max-content;\n    justify-content: center;\n    align-items: center;\n}\n\n.right-2 {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.main-2 {\n    font-size: 2.5rem;\n    line-height: 46px;\n    letter-spacing: 0;\n    font-weight: 700;\n    width: 80%;\n    text-align: start;\n}\n.image-con{\n    position: relative;\n    width: 700px;\n    height: 500px;\n    transform-style: preserve-3d;\n    perspective: 1000px;\n}\n.image-con img{\n    position: absolute;\n    backface-visibility: hidden;\n    transition: 1s;\n}\n.image-con img:nth-child(2){\n    transform: rotateY(180deg);\n}\n.image-con:hover img:nth-child(2) {\n    transform: rotateY(0deg);\n}\n.image-con:hover img:nth-child(1) {\n    transform: rotateY(-180deg);\n}\n\n.imgflipw{\n    width:80%\n}\n\n@media(max-width:1000px){\n    .imgflipw{\n        width:100%;\n        display: flex;\n        justify-content: center;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n@media (max-width: 800px) {\n    .imgflipw{\n        width:80%\n    }\n    .main-container-2 {\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n\n    .container-2 {\n        flex-direction: column;\n    }\n\n    .left-2 {\n        width: 100%;\n        margin-top: 30px;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .right-2 {\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .main-2 {\n        padding: 0 20px;\n        text-align: start;\n        width: 100%;\n        font-size: 1rem;\n        line-height: 26px;\n        letter-spacing: 0;\n        text-align: center;\n        font-weight: 500;\n    }\n        .image-con {\n            position: relative;\n            width: 700px;\n            height: 500px;\n            transform-style: preserve-3d;\n            perspective: 1000px;\n            display: flex;\n            justify-content: center;\n        }\n    \n        .image-con img {\n            position: absolute;\n            backface-visibility: hidden;\n            transition: 1s;\n        }\n    \n        .image-con img:nth-child(2) {\n            transform: rotateY(180deg);\n        }\n    \n        .image-con:hover img:nth-child(2) {\n            transform: rotateY(0deg);\n        }\n    \n        .image-con:hover img:nth-child(1) {\n            transform: rotateY(-180deg);\n        }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
